import { Skeleton, Stack } from "@mui/material";

export const BankAccountsSkeleton = () => (
  <Stack gap={2}>
    <Skeleton variant="rounded" height={56} />
    <Skeleton variant="rounded" height={56} />
  </Stack>
);
